<template>
  <v-layout column>
    <v-flex xs11 offset-xs0>
      <panel title="Manage Places">
        <!-- <v-btn
          slot="action"
          class="indigo accent-1"
          :to="{name:'rank-create'}"
          light
          small
          absolute
          right
          middle
          fab
        > 
          <v-icon>add</v-icon>
        </v-btn>-->
        <PlaceCreate v-if ='$store.state.isEditor' slot="action"/>

        <div slot="top">
         
          <div>
             <v-autocomplete v-model="place.select" :items="place.places" item-text="pn" item-value="id" label="Search for a place to manage"
                      :search-input.sync="placeSearch" :loading="place.loading" single-line return-object @change="placeChange()">     
              </v-autocomplete>
          </div>

          <template v-if="selectedPlace.id" style='text-align:left'>
            <div style='text-align:left'>
              <H3>{{ selectedPlace.name }} </H3>

              <div v-if="selectedPlace">
                <div v-if ='$store.state.isEditor' class='section'>
                <v-btn small  @click="editPlace('name')">Edit name</v-btn>
                <!-- v-btn small  @click="editPlace('hierarchy')">Move to a different place in the hierarchy</v-btn -->
                <v-btn small  @click="editPlace('merge')">Merge with another place</v-btn>     
                 <a :href='"/place/" + selectedPlace.id'>Show place details</a>           
                </div>
                <div v-if="selectedPlace.parent" class='section'>
                  <H3>{{ selectedPlace.v }} is part of </H3>
                    <router-link :to="{path: '/place/' + selectedPlace.parent.id}">{{ selectedPlace.parent.v
                  }}</router-link><span v-if="selectedPlace.parent.parent">, 
                      <router-link :to="{path: '/place/' + selectedPlace.parent.parent.id}">
                      {{ selectedPlace.parent.parent.v }}</router-link></span>
                </div>
                <div v-if="selectedPlace.children && (selectedPlace.children.length > 0)" class='section'>
                  <H3>Places that are part of {{ selectedPlace.v }}</H3>
                    <div v-for="child in selectedPlace.children" v-bind:key="child.id">
                      <router-link :to="{path: '/place/' + child.id}">{{ child.v }}</router-link>
                    </div>
                </div>
              </div>

             </div>
          </template>
        </div>         
      </panel>            
    </v-flex>
    <PlaceEdit v-if ='$store.state.isEditor' v-bind:place="selectedPlace"/>
  </v-layout>
</template>

<script>
import PlaceService from "@/services/PlaceService" ;
import Panel from "@/components/Panel" ;
import PlaceCreate from "./PlaceCreate" ;
import PlaceEdit from "./PlaceEdit" ;

export default {
  components: { Panel, PlaceCreate, PlaceEdit },
  data () {
    return {
      place: {  
        name: '',        
        select: {id: -1, pn: ""},
        places: [],
        loading: false,        
        provenance: '',
        note: '',
        pendingSearch: null
      },
      placeSearch: null, 

      selectedPlace: {
        id: 0,
        name: null,
        data: null,
        editType: null,
        showEditDialog: false
      }  
    };
  },
  methods: {

    editPlace (editType) {
      this.selectedPlace.editType = editType ;
      this.selectedPlace.showEditDialog = true ;
      console.log("editPlace " + JSON.stringify(this.selectedPlace)) ;
    },

    async placeChange () {
      console.log("---------------------------------placeChange: " + JSON.stringify(this.place.select)) ;
      this.selectedPlace.data = null ;
      this.selectedPlace.id = this.place.select.id ;
      this.selectedPlace.name = this.place.select.pn ;
      const result = await PlaceService.id(this.selectedPlace.id) ;
      this.selectedPlace.data = result.data ;
    },
    async runPlaceSearch (val, locp) {

      console.log("runPlaceSearch val: " + val) ;
      if (locp.loading) {
        locp.pendingSearch = val ;
        console.log("PENDING SEARCH QUEUED: " + val) ;
        return ;
      }
      locp.loading = true ;
      try {
        const response = await PlaceService.placeFindMatchesOnName(val, true) ;
        console.log("PlaceService responsed") ; // + JSON.stringify(response)) ;

        locp.places = response.data ;
      }
      catch (err) {
        console.log("placeQuerySelections catch err:" + JSON.stringify(err)) ;
        this.error = err.response.data.error  ;
        if (this.error === "You do not have access to this resource") {
          alert("Error: " + this.error + " - you may need to login") ;
        }
      }
      finally {
        locp.loading = false ;
        if (locp.pendingSearch) {
          const queuedSearch = locp.pendingSearch ;
          locp.pendingSearch = null ;
          console.log("Queuing pending search.." + queuedSearch) ;
          this.runPlaceSearch(queuedSearch, locp) ;
        }
      }
    }
  },

  watch: {
    async placeSearch (val) {
      if (val && val !== this.place.select.pn && (val.length >= 2)) {
        this.runPlaceSearch(val, this.place) ;
      }
    }  
  },
  async created () {
    await this.$getCodes() ;  // needed for everything - make sure we have them and they are up to date
  },  
  async mounted () {
    console.log("in mounted") ;
  }
};
</script>

<style scoped>

.section {margin-left:2em;margin-top:1em}

</style>



// WEBPACK FOOTER //
// src/components/Places.vue